<script setup lang="ts">
import { computed } from "vue"

import type { Option } from "@/types/common.type"

const randomPrefix = Math.random().toString(36).slice(2, 10)

const props = defineProps({
  options: { type: Array<Option>, required: true },
  field: { type: String, required: true },
  modelValue: { type: [String, Number, Array, Object, null], required: true },
  label: { type: String, default: "" },
  required: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  suppressRequiredMark: { type: Boolean, default: false },
})
const emits = defineEmits(["update:modelValue"])

// proxy for v-model binding
const internalValue = computed({
  get: () => props.modelValue,
  set: (v) => emits("update:modelValue", v),
})
</script>

<template>
  <div class="input-box">
    <label v-if="label" class="form-label" :for="field">
      {{ label }} <span class="text-danger" v-if="required && !suppressRequiredMark">*</span>
    </label>
    <div class="form-check-container ps-1 d-flex flex-column justify-content-start">
      <div class="form-check d-flex align-items-center" v-for="option in options" :key="option.value">
        <input
          class="cursor-pointer"
          type="radio"
          :name="field"
          :id="`${field}-${option.value}-${randomPrefix}`"
          :value="option.value"
          v-model="internalValue"
          :required="required"
          :disabled="disabled"
        />
        <label class="cursor-pointer ms-2" :for="`${field}-${option.value}-${randomPrefix}`">
          {{ option.label }}
        </label>
      </div>
    </div>
  </div>
</template>

<style scoped>
.form-label {
  font-weight: 600;
}

.form-check-container {
  .form-check {
    margin: 0;
    padding: 0;
    min-height: 0;
  }

  .form-check + .form-check {
    margin-top: 12px;
  }
}
</style>
